import { Injectable } from '@angular/core';
import { LoggerService } from '@app/logger/logger.service';
import { ApiBaseService } from './api-base.service';

const log = new LoggerService('PLACES SERVICE');

@Injectable({
  providedIn: 'root'
})
export class PlacesService extends ApiBaseService<any>{

  constructor() {
    // Le pasamos 'places' como el nombre del recurso a la clase base
    super('places');
    log.debug('Servicio de Sitios inicializado');
  }

}
